import React from 'react';
import { connect } from 'react-redux';
import 'react-resizable/css/styles.css';

import PlatformSpaceEdit from '../Space/Edit';
import PlatformSpaceView from '../Space/View';
import PlatformElement from '../Element';
import Loading from '../../Loading';
import ElementFieldLoading from '../Element/FieldLoading';
import { IRootState } from '../../../modules/stores';
import { ElementTypes } from '../../../types/element';
import { ColumnType } from '../../../modules/core/graphql/types';

import { Page } from './styled';

type IConnectProps = ReturnType<typeof mapState>;

const PlatformContent: React.FC<IConnectProps> = ({
  currentRecordId,
  editingSpaceId,
  isEditingMode,
  isSpaceLoading,
  isExpand,
  spaceById,
  shadowById,
  spaceAllIds,
  fieldById,
  isLoadingTableData,
}) => {
  return (
    <Page id="capture" isEditingMode={isEditingMode}>
      {isSpaceLoading ? (
        <Loading />
      ) : (
        spaceAllIds.map((spaceId: string) => {
          const Space = editingSpaceId === spaceId ? PlatformSpaceEdit : PlatformSpaceView;
          const shadow = isEditingMode ? null : shadowById[spaceId];
          const space = spaceById[spaceId];

          // show loading when table data is being fetched
          if (space && space.fieldId) {
            if (
              (space.type === ElementTypes.FieldRecordRef ||
                space.type === ElementTypes.FieldSubtable) &&
              isLoadingTableData
            ) {
              return (
                <Space key={spaceId} space={space} shadow={shadow}>
                  <ElementFieldLoading />
                </Space>
              );
            }
            if (space.type === ElementTypes.FieldLookup && isLoadingTableData) {
              const field = fieldById[space.fieldId];

              if (
                field &&
                (field.typeOptions.lookupColumnType === ColumnType.RECORD_REFERENCE ||
                  field.typeOptions.lookupColumnType === ColumnType.SUBTABLE)
              ) {
                return (
                  <Space key={spaceId} space={space} shadow={shadow}>
                    <ElementFieldLoading />
                  </Space>
                );
              }
            }
          }

          return (
            <Space key={spaceId} space={space} shadow={shadow}>
              <PlatformElement space={space} recordId={currentRecordId} />
            </Space>
          );
        })
      )}
    </Page>
  );
};

const mapState = ({ core, space }: IRootState) => ({
  currentRecordId: core.currentRecordId,
  fieldById: core.fieldById,
  tableById: core.tableById,
  isExpand: core.isExpand,
  editingSpaceId: space.editingSpaceId,
  isEditingMode: space.isEditingMode,
  isSpaceLoading: space.isLoading,
  isLoadingTableData: space.isLoadingTableData,
  spaceById: space.byId,
  shadowById: space.shadowById,
  spaceAllIds: space.allIds,
});

export default connect(mapState)(PlatformContent);
